import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Title, Container, SubTitle } from "./forgottenPassword.styled";
import Languages from "../../layouts/commons/header/components/languages";
import { withFormik, Field } from "formik";
import { dataModel, validationDataModel } from "./forgottenPassword.data.form";
import InputText from "../../utils/InputText";

const ForgotPWForm = (props) => {
  const { handleSubmit } = props;
  const { t } = useTranslation();

  return (
    <div className="login-page row no-margin">
      <div className="col-12">
        <div className="row justify-content-center">
          <div className="col-10 mt-2 d-flex justify-content-end">
            <Languages />
          </div>
        </div>
        <Container className="row justify-content-center align-items-center">
          <div className="col-10">
            <div className="row justify-content-center mt-5">
              <div className="col-10 mt-2 d-flex justify-content-center">
                <Title>{t("forgottenPassword.title")}</Title>
              </div>
            </div>
            <div className="row justify-content-center align-items-center mt-4">
              <div className="col-6">
                <div className="row justify-content-center">
                  <div className="col-12 mt-3 mb-2">
                    <SubTitle>{t("forgottenPassword.body")}</SubTitle>
                  </div>
                </div>
                <form
                  className="form-horizontal bordered-row"
                  onSubmit={handleSubmit}
                >
                  <div className="row">
                    <div className="col-12">
                      <Field
                        id="email"
                        className="form-control"
                        name="email"
                        component={InputText}
                        fieldType="text"
                        labelField={t("forms.provider.labels.email")}
                      />
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-12 text-center">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary btn-block"
                      >
                        {t("forgottenPassword.send")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

ForgotPWForm.propTypes = {
  handleSubmit: PropTypes.func,
  gotoLogin: PropTypes.func,
};

const ForgotPWFormF = withFormik({
  mapPropsToValues: () => dataModel,
  validationSchema: validationDataModel,
  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },

  displayName: "ForgotPWForm",
})(ForgotPWForm);

export default ForgotPWFormF;
